import React, { useState, useEffect } from "react";
import { Select, notification } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

import {
  StyledButton,
  ButtonWrapper,
  CenteredContainer,
  TargetCard,
} from "./style.js";
import axios from "axios";
import CryptoJS from "crypto-js";

import {
  MAHARASHTRA_DISTRICTS,
  LOAN_CATEGORY_RANGES,
  SCHEME_MAP,
  DIVISION_DISTRICTS,
  DM_DISTRICT_MAPPING,
  PRIVILEGED_GROUPS,
  DISTRICT_TARGETS,
  CHANGED_DISTRICTS_SET_VALUE,
  CHANGED_DISTRICTS_API,
} from "./constants";

const { Option } = Select;

const NsfdcFilters = ({ onResultsFetched, onWinnersViewed }) => {
  const [scheme, setScheme] = useState(null);
  const [category, setCategory] = useState(null);
  const [district, setDistrict] = useState(null);
  const [districtOptions, setDistrictOptions] = useState(MAHARASHTRA_DISTRICTS);
  const [viewResultsLoading, setViewResultsLoading] = useState(false);
  const [viewApplicantsLoading, setViewApplicantsLoading] = useState(false);
  const [viewWinnersWaitingLoading, setViewWinnersWaitingLoading] =
    useState(false);
  const [selectWinnersLoading, setSelectWinnersLoading] = useState(false);
  const [isPrivilegedUser, setIsPrivilegedUser] = useState(false);
  const [target, setTarget] = useState(null);

  useEffect(() => {
    if (!district) {
      setTarget("Please select a district.");
      return;
    }

    const districtData =
      DISTRICT_TARGETS[CHANGED_DISTRICTS_API[district]] ||
      DISTRICT_TARGETS[district];
    console.log("districtData:", districtData);

    if (scheme === "central-nsfdc-tl-a") {
      if (!category) {
        setTarget("Please select a category.");
        return;
      }
      const categoryTarget = districtData?.[scheme]?.[category];
      setTarget(categoryTarget ?? "No target found for the selected category.");
      return;
    }

    if (scheme) {
      const schemeTarget = districtData?.[scheme];
      setTarget(schemeTarget ?? "No target found for the selected scheme.");
      return;
    }

    setTarget("Please select a scheme.");
  }, [district, scheme, category]);

  // refresh the table when filter is selected
  useEffect(() => {
    onWinnersViewed([]); // Automatically refreshes table on filter change
  }, [scheme, category, district]);

  useEffect(() => {
    const userName = sessionStorage.getItem("name");
    const userGroup = sessionStorage.getItem("userGroup");
    if (userName) {
      setIsPrivilegedUser(PRIVILEGED_GROUPS.includes(userGroup));
      if (userName.startsWith("dm")) {
        const correctedDistrict =
          CHANGED_DISTRICTS_SET_VALUE[userName] ||
          DM_DISTRICT_MAPPING[userName] ||
          userName.substring(2);
        setDistrict(correctedDistrict);
        setDistrictOptions([correctedDistrict]);
      } else if (userName.startsWith("rm")) {
        const rmDivision = userName.substring(2);
        console.log("rmDivision", rmDivision);
        const divisionDistricts =
          DIVISION_DISTRICTS[DM_DISTRICT_MAPPING[userName]] ||
          DIVISION_DISTRICTS[rmDivision] ||
          [];
        console.log(divisionDistricts);
        setDistrictOptions(divisionDistricts);
      }
    }
  }, []);

  const handleViewResults = async () => {
    if (
      !scheme ||
      !district ||
      (scheme === "central-nsfdc-tl-a" && !category)
    ) {
      notification.error({
        message:
          "Please select a scheme, district, and category if term loan scheme is selected!",
      });
      return;
    }

    setViewResultsLoading(true);

    try {
      const userName = sessionStorage.getItem("name");
      const viewResultsCorrectedDistrict =
        CHANGED_DISTRICTS_API[district] || district;

      if (!userName) {
        const viewResultsResponse = await axios.get(
          `https://bhugolapps.com/loan/SelectedLotteryLoanFormListView?District=${viewResultsCorrectedDistrict}&LoanSchemeCode=${scheme}&selectedInLottery=True${
            scheme === "central-nsfdc-tl-a"
              ? `&loanAmountcategory=${category}`
              : ""
          }`
        );

        if (viewResultsResponse.data.length > 0) {
          const transformedData = viewResultsResponse.data.map(
            (item, index) => ({
              srNo: index + 1,
              id: item.id,
              name: item.fullName,
              contact: item.phoneNumber,
              loanAmount: item.LoanAmount,
              caste: item.CasteName,
              income: item.AnnualFamilyIncome,
              aadhar: `**** **** ${item.aadharNumber.slice(-4)}`,
            })
          );

          onWinnersViewed(transformedData);
          notification.success({ message: "Winners viewed successfully!" });
        } else {
          notification.info({ message: "Winners not selected yet!" });
          onWinnersViewed([]);
        }
      } else {
        const encryptedToken = sessionStorage.getItem("token");
        const decryptedToken = CryptoJS.AES.decrypt(
          encryptedToken,
          "y9L@91nYW%BRfc1g"
        ).toString(CryptoJS.enc.Utf8);

        const viewResultsResponse = await axios.get(
          `https://bhugolapps.com/loan/SelectedLotteryLoanFormListView?District=${viewResultsCorrectedDistrict}&LoanSchemeCode=${scheme}&selectedInLottery=True${
            scheme === "central-nsfdc-tl-a"
              ? `&loanAmountcategory=${category}`
              : ""
          }`,
          {
            headers: {
              Authorization: `token ${decryptedToken}`,
            },
          }
        );

        if (viewResultsResponse.data.length > 0) {
          const transformedData = viewResultsResponse.data.map(
            (item, index) => ({
              srNo: index + 1,
              id: item.id,
              name: item.fullName,
              contact: item.phoneNumber,
              loanAmount: item.LoanAmount,
              caste: item.CasteName,
              income: item.AnnualFamilyIncome,
              aadhar: `**** **** ${item.aadharNumber.slice(-4)}`,
            })
          );

          onWinnersViewed(transformedData);
          notification.success({ message: "Winners viewed successfully!" });
        } else {
          if (sessionStorage.getItem("userGroup") == "districtManager") {
            console.log("winners not selected yet, DM");
            try {
              const selectWinnersResponse = await axios.post(
                `https://bhugolapps.com/loan/lotterySelection`,
                {
                  district: viewResultsCorrectedDistrict,
                  LoanSchemeCode: scheme,
                  ...(category && { termLoanCategory: category }),
                },
                {
                  headers: {
                    Authorization: `token ${decryptedToken}`,
                  },
                }
              );
              if (selectWinnersResponse.status === 200) {
                notification.success({
                  message: "Winners selected successfully!",
                });
                const transformedData =
                  selectWinnersResponse.data.selected_data.map(
                    (item, index) => ({
                      srNo: index + 1,
                      id: item.id,
                      name: item.fullName,
                      contact: item.phoneNumber,
                      loanAmount: item.LoanAmount,
                      caste: item.CasteName,
                      income: item.AnnualFamilyIncome,
                      aadhar: `**** **** ${item.aadharNumber.slice(-4)}`,
                    })
                  );
                onWinnersViewed(transformedData);
              }
            } catch (error) {
              console.log(error);
              notification.info({ message: error.response.data.message });
              if (
                error.response.data.message ==
                "No loan applications available for the lottery."
              ) {
                onWinnersViewed([]);
              }
            }
          } else {
            notification.info({ message: "Winners not selected yet!" });
          }
        }
      }
    } catch (error) {
      notification.error({ message: error.response.data.message });
    } finally {
      setViewResultsLoading(false);
    }
  };

  const handleViewApplicants = async () => {
    if (
      !scheme ||
      !district ||
      (scheme === "central-nsfdc-tl-a" && !category)
    ) {
      notification.error({
        message:
          "Please select a scheme, district, and category if term loan scheme is selected!",
      });
      return;
    }

    setViewApplicantsLoading(true);

    try {
      const viewApplicantsCorrectedDistrict =
        CHANGED_DISTRICTS_API[district] || district;
      console.log(
        "viewApplicantsCorrectedDistrict",
        viewApplicantsCorrectedDistrict
      );

      const viewResultsResponse = await axios.get(
        `https://bhugolapps.com/loan/SelectedLotteryLoanFormListView?District=${viewApplicantsCorrectedDistrict}&LoanSchemeCode=${scheme}${
          scheme === "central-nsfdc-tl-a"
            ? `&loanAmountcategory=${category}`
            : ""
        }`
      );

      if (viewResultsResponse.data.length > 0) {
        const transformedData = viewResultsResponse.data.map((item, index) => ({
          srNo: index + 1,
          id: item.id,
          name: item.fullName,
          contact: item.phoneNumber,
          loanAmount: item.LoanAmount,
          caste: item.CasteName,
          income: item.AnnualFamilyIncome,
          aadhar: `**** **** ${item.aadharNumber.slice(-4)}`,
        }));

        onWinnersViewed(transformedData);
        notification.success({ message: "Applicants viewed successfully!" });
      } else {
        notification.info({ message: "No Applicants found" });
        onWinnersViewed([]);
      }
    } catch (error) {
      notification.error({ message: error.response.data.message });
    } finally {
      setViewApplicantsLoading(false);
    }
  };

  const handleViewWinnersWaitingList = async () => {
    if (
      !scheme ||
      !district ||
      (scheme === "central-nsfdc-tl-a" && !category)
    ) {
      notification.error({
        message:
          "Please select a scheme, district, and category if term loan scheme is selected!",
      });
      return;
    }

    console.log("View Winners Waiting List button clicked");
    setViewWinnersWaitingLoading(true);

    try {
      const userName = sessionStorage.getItem("name");
      const viewWaitingCorrectedDistrict =
        CHANGED_DISTRICTS_API[district] || district;

      if (!userName) {
        // Guest user – no token required
        const response = await axios.get(
          `https://bhugolapps.com/loan/SelectedLotteryLoanFormListView?District=${viewWaitingCorrectedDistrict}&LoanSchemeCode=${scheme}&selectedInWaitingList=True${
            scheme === "central-nsfdc-tl-a"
              ? `&loanAmountcategory=${category}`
              : ""
          }`
        );

        if (response.data.length > 0) {
          const transformedData = response.data.map((item, index) => ({
            srNo: index + 1,
            id: item.id,
            name: item.fullName,
            contact: item.phoneNumber,
            loanAmount: item.LoanAmount,
            caste: item.CasteName,
            income: item.AnnualFamilyIncome,
            aadhar: `**** **** ${item.aadharNumber.slice(-4)}`,
          }));

          onWinnersViewed(transformedData);
          notification.success({
            message: "Winners waiting list viewed successfully!",
          });
        } else {
          notification.info({ message: "Insufficient applications" });
          onWinnersViewed([]);
        }
      } else {
        // Authenticated user – use decrypted token
        const encryptedToken = sessionStorage.getItem("token");
        const decryptedToken = CryptoJS.AES.decrypt(
          encryptedToken,
          "y9L@91nYW%BRfc1g"
        ).toString(CryptoJS.enc.Utf8);

        const response = await axios.get(
          `https://bhugolapps.com/loan/SelectedLotteryLoanFormListView?District=${viewWaitingCorrectedDistrict}&LoanSchemeCode=${scheme}&selectedInWaitingList=True${
            scheme === "central-nsfdc-tl-a"
              ? `&loanAmountcategory=${category}`
              : ""
          }`,
          {
            headers: {
              Authorization: `token ${decryptedToken}`,
            },
          }
        );

        if (response.data.length > 0) {
          const transformedData = response.data.map((item, index) => ({
            srNo: index + 1,
            id: item.id,
            name: item.fullName,
            contact: item.phoneNumber,
            loanAmount: item.LoanAmount,
            caste: item.CasteName,
            income: item.AnnualFamilyIncome,
            aadhar: `**** **** ${item.aadharNumber.slice(-4)}`,
          }));

          onWinnersViewed(transformedData);
          notification.success({
            message: "Winners waiting list viewed successfully!",
          });
        } else {
          // Auto-run waiting list if District Manager
          if (sessionStorage.getItem("userGroup") === "districtManager") {
            try {
              const postResponse = await axios.post(
                `https://bhugolapps.com/loan/lotteryWaitingListSelection`,
                {
                  district: viewWaitingCorrectedDistrict,
                  LoanSchemeCode: scheme,
                  ...(category && { termLoanCategory: category }),
                },
                {
                  headers: {
                    Authorization: `token ${decryptedToken}`,
                  },
                }
              );

              if (postResponse.status === 200) {
                notification.success({
                  message: "Waiting list winners selected successfully!",
                });

                const transformedData = postResponse.data.data.map(
                  (item, index) => ({
                    srNo: index + 1,
                    id: item.id,
                    name: item.fullName,
                    contact: item.phoneNumber,
                    loanAmount: item.LoanAmount,
                    caste: item.CasteName,
                    income: item.AnnualFamilyIncome,
                    aadhar: `**** **** ${item.aadharNumber.slice(-4)}`,
                  })
                );
                onWinnersViewed(transformedData);
              }
            } catch (err) {
              console.error(err);
              const errorMsg =
                err?.response?.data?.message || "Insufficient applications";
              notification.info({ message: errorMsg });
              onWinnersViewed([]);
              if (
                err?.response?.data?.message ===
                "No applicants available for waiting list."
              ) {
                onWinnersViewed([]);
              }
            }
          } else {
            notification.info({ message: "Insufficient applications" });
            onWinnersViewed([]);
          }
        }
      }
    } catch (error) {
      console.error(error);
      const errorMsg =
        error?.response?.data?.message || "Something went wrong.";
      notification.error({ message: errorMsg });
    } finally {
      setViewWinnersWaitingLoading(false);
    }
  };

  const getDownloadUrl = () => {
    const downloadurlCorrectedDistrict =
      CHANGED_DISTRICTS_API[district] || district;
    const baseUrl = "https://bhugolapps.com/loan/downloadLotteryloans";
    const queryParams = new URLSearchParams({
      District: downloadurlCorrectedDistrict || "",
      selectedInLottery: "True",
      LoanSchemeCode: scheme || "",
      termLoanCategory: category || "",
    });
    return `${baseUrl}?${queryParams.toString()}`;
  };

  const getWaitingListDownloadUrl = () => {
    const downloadurlCorrectedDistrict =
      CHANGED_DISTRICTS_API[district] || district;
    const baseUrl = "https://bhugolapps.com/loan/downloadLotteryloans";
    const queryParams = new URLSearchParams({
      District: downloadurlCorrectedDistrict || "",
      selectedInWaitingList: "True",
      LoanSchemeCode: scheme || "",
      termLoanCategory: category || "",
    });
    return `${baseUrl}?${queryParams.toString()}`;
  };

  const handleDownload = async () => {
    const url = getDownloadUrl();

    try {
      const response = await fetch(url);

      // Try to parse JSON to detect an error message
      const contentType = response.headers.get("content-type");

      if (contentType && contentType.includes("application/json")) {
        const json = await response.json();
        if (json.success === "error") {
          notification.error({ message: "Winners not selected yet" });
          onWinnersViewed([]);
          return;
        }
      }

      // If it's a file (Excel), download it
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = "WinnerResults.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
      notification.error({ message: "Failed to download Excel file" });
    }
  };

  const handleWaitingListDownload = async () => {
    const url = getWaitingListDownloadUrl();

    try {
      const response = await fetch(url);

      // Try to parse JSON to detect an error message
      const contentType = response.headers.get("content-type");

      if (contentType && contentType.includes("application/json")) {
        const json = await response.json();
        if (json.success === "error") {
          notification.info({
            message: "Insufficient applicants",
          });
          onWinnersViewed([]);
          return;
        }
      }

      // If it's a file (Excel), download it
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = "WaitingListResults.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);
      notification.error({ message: "Failed to download Excel file" });
    }
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      {/* Filter Row - Centered */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "16px",
          marginBottom: "20px",
        }}
      >
        <Select
          placeholder="Select Scheme"
          style={{ width: 200 }}
          onChange={(value) => {
            setScheme(SCHEME_MAP[value]);
            if (value !== "Term Loan") setCategory(null);
          }}
        >
          {Object.keys(SCHEME_MAP).map((schemeName) => (
            <Option key={schemeName} value={schemeName}>
              {schemeName}
            </Option>
          ))}
        </Select>

        {scheme === "central-nsfdc-tl-a" && (
          <Select
            placeholder="Select Category"
            style={{ width: 200 }}
            onChange={(value) => {
              console.log("Selected value:", value);
              setCategory(value);
            }}
          >
            {Object.entries(LOAN_CATEGORY_RANGES).map(([key, label]) => (
              <Option key={key} value={key}>
                {label}
              </Option>
            ))}
          </Select>
        )}

        <Select
          showSearch
          placeholder="Select District"
          style={{ width: 200 }}
          value={district}
          onChange={setDistrict}
          disabled={districtOptions.length === 1}
        >
          {districtOptions.map((districtOption) => (
            <Option key={districtOption} value={districtOption}>
              {districtOption}
            </Option>
          ))}
        </Select>
      </div>

      {/* Button Row */}
      <CenteredContainer>
        <ButtonWrapper>
          <StyledButton
            type="primary"
            onClick={handleViewResults}
            loading={viewResultsLoading}
          >
            View Winners Results
          </StyledButton>

          <StyledButton
            type="primary"
            onClick={handleViewApplicants}
            loading={viewApplicantsLoading}
          >
            View Applicants
          </StyledButton>

          {isPrivilegedUser && (
            <StyledButton
              type="primary"
              onClick={handleViewWinnersWaitingList}
              loading={viewWinnersWaitingLoading}
            >
              View Waiting List
            </StyledButton>
          )}
        </ButtonWrapper>
      </CenteredContainer>

      {/* Download Buttons and Target Row */}
      {isPrivilegedUser && (
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
            gap: "16px",
            marginTop: "20px",
          }}
        >
          <StyledButton
            type="primary"
            onClick={handleDownload}
            disabled={
              !district ||
              !scheme ||
              (scheme === "central-nsfdc-tl-a" && !category)
            }
          >
            Download Winners Results Excel
          </StyledButton>

          <StyledButton
            type="primary"
            onClick={handleWaitingListDownload}
            disabled={
              !district ||
              !scheme ||
              (scheme === "central-nsfdc-tl-a" && !category)
            }
          >
            Download Waiting List Excel
          </StyledButton>

          {target && (
            <TargetCard>
              <FontAwesomeIcon
                icon={faUser}
                style={{ fontSize: "18px", color: "black" }}
              />
              Target: {target}
            </TargetCard>
          )}
        </div>
      )}
    </div>
  );
};

export default NsfdcFilters;
